"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CONTACT_INFO_KEY = 'mbContactInfoBox.';
const MODAL_TRUSTED_DEVICES_KEY = 'mbModal.trustedDevices.';
const A11Y = 'a11y.';
const buildKey = (MAINKEY, SUBKEY, a11y = false) => (a11y ? `${A11Y}${MAINKEY}${SUBKEY}` : `${MAINKEY}${SUBKEY}`);
exports.default = {
    CONTACT_INFO: {
        TITLE: buildKey(CONTACT_INFO_KEY, 'basicTitle'),
        SUBTITLE: buildKey(CONTACT_INFO_KEY, 'basicDescription01'),
        SUBTITLE_DESCRIPTION: buildKey(CONTACT_INFO_KEY, 'basicDescription02'),
        BUTTON_TEXT: buildKey(CONTACT_INFO_KEY, 'callUsButton'),
        A11Y_BUTTON_TEXT: buildKey(CONTACT_INFO_KEY, 'callUsButton', true),
        FOOTER_DESCRIPTION: buildKey(CONTACT_INFO_KEY, 'basicHelpDescription'),
        FOOTER_DESCRIPTION_MOBILE_01: buildKey(CONTACT_INFO_KEY, 'basicHelpDescription01'),
        FOOTER_DESCRIPTION_MOBILE_02: buildKey(CONTACT_INFO_KEY, 'basicHelpDescription02'),
        CFG_PHONE: 'cfg_relay_service_number',
    },
    CONTACT_INFO_MODALTD: {
        TITLE: buildKey(MODAL_TRUSTED_DEVICES_KEY, 'title'),
        DESCRIPTION: buildKey(MODAL_TRUSTED_DEVICES_KEY, 'description'),
        BUTTON_TEXT: buildKey(MODAL_TRUSTED_DEVICES_KEY, 'continueButton'),
        A11Y_CLOSE_LINK: buildKey(MODAL_TRUSTED_DEVICES_KEY, 'closeLink', true),
    },
};
//# sourceMappingURL=translations.js.map